import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import axios from 'axios'; // Import axios
import { base_url } from '../admin/components/AdminUsers'; // Import your base URL


const Banner = () => {
    const [banners, setBanners] = useState([]); 
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

   // In your Banner.js component
useEffect(() => {
  const fetchBanners = async () => {
      try {
          const response = await axios.get(`${base_url}/api/webapi/getAllBanner`);
          if (response.data.success) {
              // Filter only active banners
              console.log(response.data.data,"hgtfr");
              const activeBanners = response.data.data.filter(banner => 
                  banner.status === 'Active'
              );
          
              setBanners(activeBanners);
          } else {
              setError(response.data.message || "Failed to fetch banners");
          }
      } catch (err) {
          console.error("Error fetching banners:", err);
          setError("An error occurred while fetching banners.");
      } finally {
          setIsLoading(false);
      }
  };

  fetchBanners();
}, []);

    var settings = {
        speed: 1500,
        infinite: true,
        slidesToShow: 3,
        autoplay: true,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    if (isLoading) {
        return <div className='slider-container'>Loading banners...</div>; // Or a spinner
    }

    if (error) {
        return <div className='slider-container'>Error: {error}</div>;
    }

    return (
        <div className="slider-container">
            <Slider {...settings} style={{ marginLeft: "5px" }}>
                {banners.map((banner) => (
                    <div key={banner.id}> {/* Important: Add a unique key */}
                        <img src={base_url + banner.attachment} alt={banner.title || "Banner"} /> {/* Dynamic image src */}
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default Banner;